import { render, staticRenderFns } from "./ModalEditarCompraDiretaId.vue?vue&type=template&id=4bc8419a&scoped=true"
import script from "./ModalEditarCompraDiretaId.vue?vue&type=script&lang=js"
export * from "./ModalEditarCompraDiretaId.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarCompraDiretaId.vue?vue&type=style&index=0&id=4bc8419a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc8419a",
  null
  
)

export default component.exports